function multiWordFilterFn(
	rows,
	ids,
	filterValue
) {
	if ( filterValue.length === 0 ) {
		return rows;
	}

	let filteredRows = rows.filter( row => {
		return ids.some( id => {
			const rowValue = row.values[ id ];
			const words = String( filterValue )
				.toLowerCase()
				.replaceAll( /[^a-zA-Z0-9()\-+=.` ]/g, '' ) // remove any characters that aren't allowed
				.split( /(?<![`][a-zA-Z0-9()-.]+)[^a-zA-Z0-9()\-+=.`](?![a-zA-Z0-9()-.]+[`])/g ) // split it into separate words
				.filter( i => i.length )
				.map( w => w.replaceAll( '`', '' ) );

			return words.every( w => w.includes( '+' )
				?	w.split( '+' )
					.filter( i => i.length )
					.some( word => word.startsWith( '=' )
						? word.length === 1
							? true
							: new RegExp( `.*(^|[^a-zA-Z0-9()-.])${ word.replace( '=', '' ) }($|[^a-zA-Z0-9()-.]).*` ).test( String( rowValue ).toLowerCase() )
						: String( rowValue )
							.toLowerCase()
							.includes( word ) )
				: w.startsWith( '=' )
					? w.length === 1
						? true
						: new RegExp( `.*(^|[^a-zA-Z0-9()-.])${ w.replace( '=', '' ) }($|[^a-zA-Z0-9()-.]).*` ).test( String( rowValue ).toLowerCase() )
					: String( rowValue )
						.toLowerCase()
						.includes( w ) );
		} );
	} );

	return filteredRows;
}

multiWordFilterFn.autoRemove = val => !val;

export default multiWordFilterFn;
